module.exports = __webpack_public_path__ + "img/map-step_5.56276d3.webp";